import * as React from "react";
import { getSessionStorageItem } from "./get-session-storage-item.js";
import { setSessionStorageItem } from "./set-session-storage-item.js";
function useSessionStorage(key, initialValue, shouldRemove = (v) => v === null) {
  const [value, setValue] = React.useState(() => {
    const item = getSessionStorageItem(key);
    if (item !== null) {
      try {
        return JSON.parse(item);
      } catch {
        return initialValue;
      }
    }
    return initialValue;
  });
  React.useDebugValue(value, (v) => ({ key, value: v }));
  React.useEffect(() => {
    try {
      shouldRemove(value) ? globalThis.sessionStorage.removeItem(key) : setSessionStorageItem(key, value);
    } catch (err) {
    }
  }, [key, value]);
  return [value, setValue];
}
export {
  useSessionStorage
};
//# sourceMappingURL=use-session-storage.js.map
